import moment from 'moment-timezone';

import { DEFAULT_TIMEZONE } from 'constants/timezones';

let activeTimezone = DEFAULT_TIMEZONE;

export function setActiveTimezone(timezone) {
  activeTimezone = resolveTimezone(timezone);
}

export function getActiveTimezone() {
  return activeTimezone;
}

export function resolveTimezone(timezone) {
  const tz = String(timezone || '').trim();
  if (tz && moment.tz.zone(tz)) {
    return tz;
  }
  return DEFAULT_TIMEZONE;
}

export function formatDateTime(iso, options = {}) {
  if (iso == null || iso === '') return '—';
  const tz = resolveTimezone(options.timezone || getActiveTimezone());
  const m = moment.utc(iso);
  if (!m.isValid()) return String(iso);
  const fmt = options.format || 'MMM D, YYYY h:mm A';
  return m.tz(tz).format(fmt);
}

export function formatDate(iso, options = {}) {
  return formatDateTime(iso, {
    ...options,
    format: options.format || 'MMM D, YYYY',
  });
}

export function formatDateShort(iso, options = {}) {
  return formatDateTime(iso, {
    ...options,
    format: options.format || 'MMM D, YYYY',
  });
}

export function formatTimeNow(timezone) {
  return moment()
    .tz(resolveTimezone(timezone || getActiveTimezone()))
    .format('ddd, MMM D, YYYY h:mm A z');
}

export function formatDateInput(iso, options = {}) {
  if (iso == null || iso === '') return '';
  return formatDateTime(iso, {
    ...options,
    format: options.format || 'YYYY-MM-DD',
  });
}

export function formatTimeShort(iso, options = {}) {
  return formatDateTime(iso, {
    ...options,
    format: options.format || 'HH:mm',
  });
}

export function formatNumber(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return '0';
  return num.toLocaleString();
}
